import { Modal, Box, Button, Alert } from "@mui/material";
import React, { useState } from "react";

import { modalStyle } from "../constants";
import { sendPostRequest } from "../../utils";

const DeleteSubscriberModal = ({
  open,
  handleClose,
  doFetchCustomers,
  user,
}) => {
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const doDeleteSubscriber = async () => {
    setIsSubmitting(true);
    sendPostRequest("delete-subscriber", {
      id: user.id,
    })
      .then((res) => res.json())
      .then((data) => {
        setIsSubmitting(false);
        if (data.errMessage) {
          setError(data.errMessage);
        }
        if (data.message) {
          doFetchCustomers();
          handleClose();
        }
      })
      .catch((err) => {
        setIsSubmitting(false);
        setError("Failed to delete subscriber. Please try again.");
      });
  };

  return (
    <Modal open={open} onClose={handleClose} className="relative">
      <Box sx={modalStyle}>
        {error ? (
          <div className="my-4">
            <Alert severity="error">{error}</Alert>
          </div>
        ) : null}

        <div className="my-6">
          <p>
            Are you sure you want to permanently delete{" "}
            <b>{user.name}</b>?
          </p>
          <p className="mt-2 text-sm text-gray-600">
            This will archive the customer data and remove them from the active list.
            This action cannot be undone.
          </p>
        </div>
        <div className="flex justify-center">
          <Button
            type="submit"
            variant="contained"
            onClick={doDeleteSubscriber}
            disabled={isSubmitting}
            color="error"
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </Button>
          <span className="ml-2">
            <Button
              type="submit"
              variant="outlined"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </span>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteSubscriberModal;
